import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0053',
    ecrans: ['00-2'],
    params: [
        '?reference'
    ]
});
